import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ISearchInputs } from 'src/app/models/application-form/search-form.model';
import { FormGroupStringType } from 'src/app/models/shared/shared-types';
import { ApplicationSearchAbstractService } from 'src/app/services/application-search/application-search.abstract.service';

@Component({
  selector: 'app-search-header',
  templateUrl: './search-header.component.html',
  styleUrls: ['./search-header.component.css'],
})
export class SearchHeaderComponent implements OnInit {
  private _searchFilters: FormGroup<FormGroupStringType>;
  private _filterOption: ISearchInputs[];

  public get searchFilters(): FormGroup<FormGroupStringType> {
    return this._searchFilters;
  }

  public get filterOption(): ISearchInputs[] {
    return this._filterOption;
  }
  constructor(private applicationSearchService: ApplicationSearchAbstractService) {

  }

  ngOnInit(): void {
    this._searchFilters = this.applicationSearchService.searchFilters;
    this._filterOption = this.applicationSearchService.filterOption;
  }
}
